module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pageTitle":"Questions du quiz","newQuestion":"Nouvelle question","errorLoadingThemes":"Une erreur est survenue lors du chargement des thèmes","loading":"Chargement en cours"},"en":{"pageTitle":"Quiz questions","newQuestion":"New question","errorLoadingThemes":"An error occurred while loadign the question themes","loading":"Loading..."}}')
  delete Component.options._Ctor
}
